module.exports = __webpack_public_path__ + "static/media/YF100_3.28b9d623.jpg";